<template>
  <div class="home-screen">
    <!-- Hero -->
    <div class="home-hero">
      <div class="hero-orb">🧠</div>
      <h1 class="hero-title">BilimBor!</h1>
      <p class="hero-sub">Bilimingizni sinab ko'ring va reyting jadvalida yuqoriga chiqing</p>
    </div>

    <!-- Stats -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-val">{{ this.$store.totalPlayed }}</div>
        <div class="stat-lbl">O'yinlar</div>
      </div>
      <div class="stat-card">
        <div class="stat-val">{{ this.$store.accuracy }}%</div>
        <div class="stat-lbl">Aniqlik</div>
      </div>
      <div class="stat-card">
        <div class="stat-val">#{{ myRank }}</div>
        <div class="stat-lbl">Reyting</div>
      </div>
    </div>

    <!-- Categories -->
    <div class="section-title">Kategoriyalar</div>
    <div class="categories">
      <div
        v-for="cat in CATEGORIES"
        :key="cat.key"
        class="cat-card"
        :style="{ '--cat-color': cat.color, '--cat-color2': cat.color2 }"
        @click="$emit('start-quiz', cat.key)"
      >
        <div class="cat-icon">{{ cat.emoji }}</div>
        <div class="cat-info">
          <div class="cat-name">{{ cat.name }}</div>
          <div class="cat-meta">{{ cat.desc }}</div>
        </div>
        <div class="cat-badge">10 ta</div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from 'vuex';
import { CATEGORIES, MOCK_LEADERBOARD } from '../../data/questions'

export default {
  name: 'HomeView',
  emits: ['start-quiz'],

  data() {
    return { store, CATEGORIES }
  },

  computed: {
    myRank() {
      return MOCK_LEADERBOARD.filter(l => l.pts > this.$store.totalPts).length + 1
    },
  },
}
</script>
